import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useDataLayerValue } from "../../../DataLayer/DataLayer";
import Layout from "../../../Layout";
import CrisisDataInput from "../../../components/CrisisDataInput/CrisisDataInput";
import HeaderBread from "../../../components/HeaderBread";
import CustomHeaderTitle from "../../../components/constants/CustomHeaderTitle";
import { getCrisisData } from "../../../utils/ApiCalls/CrisisData";

const EditCrisisData = () => {
  const params = useParams();
  const [crisisdata, setCrisisData] = useState({});
  const [, dispatch] = useDataLayerValue();
  const navigation = [
    {
      title: "Home",
      route: "/",
    },
    {
      title: "crisisdata",
      route: "/website/cms/crisis-page/Crisis-data",
    },
    {
      title: "Edit crisisdata",
      route: "/website/cms/news-letter/edit",
    },
  ];
  useEffect(() => {
    getData(params?.id);
  }, [params]);

  const getData = async (value) => {
    dispatch({
      type: "SET_LOADING",
      loading: true,
    });
    let data = await getCrisisData({ id: value });

    if (data.error)
      dispatch({
        type: "SET_ERROR_MESSAGE",
        errMess: { message: data.error, type: "error" },
      });
    else if (data.count === 1) {
      setCrisisData(data.data[0]);
    }
    dispatch({
      type: "SET_LOADING",
      loading: false,
    });
  };
  return (
    <Layout type={"update_per"} module_data={"Crisis data"}>
      <CustomHeaderTitle title={"Edit Crisis data"} />
      <HeaderBread
        navigation={navigation}
        title={"Edit Crisis data"}
      ></HeaderBread>
      {crisisdata && <CrisisDataInput crisisdata={crisisdata} />}
    </Layout>
  );
};

export default EditCrisisData;
